package com.example.borshi.web.firebase

import kotlinx.browser.window

// Firebase Web config (Project Settings -> Web App)
// Now reads from environment variables injected at build time

private external interface FirebaseConfigData {
    val apiKey: String
    val authDomain: String
    val projectId: String
    val storageBucket: String
    val messagingSenderId: String
    val appId: String
    val measurementId: String?
}

object FirebaseConfig {
    private val config: FirebaseConfigData? by lazy {
        try {
            window.asDynamic().FIREBASE_CONFIG?.unsafeCast<FirebaseConfigData>()
        } catch (e: Exception) {
            console.error("Failed to read Firebase config from window.FIREBASE_CONFIG", e)
            null
        }
    }


    val apiKey: String
        get() = config?.apiKey ?: ""

    val authDomain: String
        get() = config?.authDomain ?: ""

    val projectId: String
        get() = config?.projectId ?: ""

    val storageBucket: String
        get() = config?.storageBucket ?: ""

    val messagingSenderId: String
        get() = config?.messagingSenderId ?: ""

    val appId: String
        get() = config?.appId ?: ""

    val measurementId: String?
        get() = config?.measurementId

    fun isConfigured(): Boolean {
        return apiKey.isNotEmpty() &&
               authDomain.isNotEmpty() &&
               projectId.isNotEmpty() &&
               storageBucket.isNotEmpty() &&
               appId.isNotEmpty()
    }

    fun getConfig(): dynamic {
        if (!isConfigured()) {
            console.warn("Firebase configuration is incomplete or missing. Please set environment variables.")
        }

        return js("""({
            apiKey: this.apiKey,
            authDomain: this.authDomain,
            projectId: this.projectId,
            storageBucket: this.storageBucket,
            messagingSenderId: this.messagingSenderId,
            appId: this.appId,
            measurementId: this.measurementId
        })""")
    }
}
